module.exports = __webpack_public_path__ + "static/media/slika3.2d4f15e4.png";